import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "bootstrap/dist/css/bootstrap.min.css"
import { sanitizeUrlParams } from "@/functions/sanitizeUrlParams"

// Strip any ?param=undefined/null/etc. from the entry URL before the router
// resolves the initial route or any page reads window.location.search.
sanitizeUrlParams()

createApp(App).use(store).use(router).mount('#app')
